import { themeGet, Chip, pxToRem } from '@pocketlaw/tetris';
import styled from 'styled-components';
const getOutlineColorFromType = (type) => {
    switch (type) {
        case 'category:commercial':
            return themeGet('colors.yellow.500');
        case 'category:compliance':
            return themeGet('colors.orange.600');
        case 'category:corporate':
            return themeGet('colors.magenta.500');
        case 'category:data':
            return themeGet('colors.indigo.500');
        case 'category:hr':
            return themeGet('colors.teal.500');
        case 'category:intellectual':
            return themeGet('colors.blue.500');
        default:
            return undefined;
    }
};
const getTextColorFromType = (type) => {
    switch (type) {
        case 'category:commercial':
            return themeGet('colors.text.200');
        case 'category:compliance':
            return themeGet('colors.orange.600');
        case 'category:corporate':
            return themeGet('colors.magenta.500');
        case 'category:data':
            return themeGet('colors.indigo.500');
        case 'category:hr':
            return themeGet('colors.teal.500');
        case 'category:intellectual':
            return themeGet('colors.blue.500');
        default:
            return undefined;
    }
};
export const StyledChip = styled(Chip) `
  & > div,
  & > button {
    border: unset;
    outline-style: solid;
    outline-width: ${pxToRem(1)};
    outline-offset: ${pxToRem(-1)};
    outline-color: ${props => getOutlineColorFromType(props.$type)};

    & > span {
      color: ${props => getTextColorFromType(props.$type)} !important;
    }

    & > [data-icon='falcon'] {
      color: ${props => getTextColorFromType(props.$type)} !important;
    }
  }
`;
